/*
 command line to update code:
 browserify ./lib/sessions.js -o ./assets/js/sessions.js

 /** Please Keep ./sx1/client/app/js/newSessions.js in Parity with Website's version.  **\/

 */
import Cookies from 'cookies-js';
var PSSessions = window.PSSessions || {};

PSSessions.Cookies = Cookies;

var set = {
  state: function(dateString) {
    PSSessions.Cookies('PSState', dateString);
  },
  userName: function(userName) {
    PSSessions.Cookies('PSName', userName);
  },
  accessToken: function(userName, curr_date, expires_in) {
    //expires_in returns from backend in seconds
    var opts = {};
    var expire_date = curr_date + (expires_in * 1000);
    var exp = new Date(expire_date);
    opts.expires = exp;
    // use expiration from the backend
    PSSessions.Cookies('PSAccess', userName, opts);
  },
  metro: function setMetroCookie (metro) {
    const isSameMetro = (metro === PSSessions.Cookies('PSmetro'));
    if (metro && !isSameMetro) {
      PSSessions.Cookies.set('PSmetro', metro, Date.now() + 3888000000); /* 45 days */
    }
  },
  thisCookie: function(key, value, optionalExpiration) {
    var opts;
    if (optionalExpiration) {
      opts = {};
      opts.expires = optionalExpiration;
    } else {
      opts = PSSessions.Cookies.defaults;
    }
    PSSessions.Cookies(key, value, opts);
  }
};

var eventHandlers = {
  onload: function(event) {
  },
  logout: function() {
    PSSessions.Cookies.expire('PSName');
    PSSessions.Cookies.expire('PSAccess');
    PSSessions.Cookies.expire('PSRefresh');
    PSSessions.Cookies.expire('PSUser');
    PSSessions.Cookies.expire('PS');
    try {
      localStorage.clear();
    } catch(e) {
      // just move on
    }
  },
  clearOldSession:  function(hasLs) {
    try {
      localStorage.clear();
    } catch(e) {
      // just move on
    }
    GSAVESESSION.cookieJar.trashCookie();
    PSSessions.Cookies.expire('PS');
    location.reload(true);
  }
};

PSSessions.set = set;
PSSessions.eH = eventHandlers;

// default values for cookie attributes
PSSessions.Cookies.defaults = {
  // default to expiring in 2 weeks
  expires: new Date((Date.now())+(60*60*24*14*1000)),
  // pull domain from url
  domain: location.hostname,
  // path is the root so all the paths see the cookie
  path: "/",
  // dynamically assign secure variable depending on protocol
  secure: location.protocol.indexOf("s") !== -1 ? true : false
};

window.PSSessions = PSSessions;
